export const SITE_URL = "https://tnnafrica.org";

export function setMetaTags({ title, description, path = "/", image }) {
  if (title) document.title = title;
  const url = SITE_URL + path;
  const set = (selector, attr, value) => {
    let el = document.querySelector(selector);
    if (!el && value) {
      el = document.createElement("meta");
      const [kind, name] = selector.match(/\[(name|property)="(.+?)"\]/).slice(1);
      el.setAttribute(kind, name);
      document.head.appendChild(el);
    }
    if (el && value) el.setAttribute(attr, value);
  };
  set('meta[name="description"]', "content", description);
  set('meta[property="og:title"]', "content", title);
  set('meta[property="og:description"]', "content", description);
  set('meta[property="og:url"]', "content", url);
  set('meta[name="twitter:title"]', "content", title);
  set('meta[name="twitter:description"]', "content", description);
  if (image) {
    const img = image.startsWith("http") ? image : SITE_URL + image;
    set('meta[property="og:image"]', "content", img);
    set('meta[name="twitter:image"]', "content", img);
    set('meta[name="twitter:card"]', "content", "summary_large_image");
  }
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute("href", url);
}
